import { IReplenishmentRequest } from 'interfaces';
import { Registry } from '.';

export default ({ get }: Registry) => {
  return {
    getReplenishmentRequests: (): Promise<Array<IReplenishmentRequest>> => get(`/api/v1/replenishment/`),
    getKardexReplenishmentRequests: (): Promise<Array<IReplenishmentRequest>> => get(`/api/v1/replenishment/kardex`),
  };
};
